import api from "@/api";

export default class Supplier {
  constructor(rawdata = {}) {
    // this.__required = ["name", "address", "contact", "telephone"];
    this.id = rawdata.id ? rawdata.id : 0;
    this.name = rawdata.name ? rawdata.name : "";
    this.address = rawdata.address ? rawdata.address : "";
    // this.contact = rawdata.contact ? rawdata.contact : "";
    this.telephone = rawdata.telephone ? rawdata.telephone : "";
    this.currency_id = rawdata.currency_id ? rawdata.currency_id : "";
    this.contact_person = rawdata.contact_person ? rawdata.contact_person : "";
    this.contact_title = rawdata.contact_title ? rawdata.contact_title : "";

    if (typeof rawdata.currency == "object") {
      this.currency = rawdata.currency;
      this.currency_id = rawdata.currency.id;
    } else {
      this.currency = {};
    }
    // this.remarks = rawdata.remarks ? rawdata.remarks : "";
  }

  static async create(payload) {
    const result = await api.post("/api/v1/suppliers/create/", payload);
    if (result && result.status == 200) return result.data.data;
    return null;
  }

  static async fetch(payload) {
    const result = await api.get(`/api/v1/suppliers/supplier/${payload}/`);
    if (result && result.status == 200) return result.data.data[0];
    return null;
  }

  static async getGlossary() {
    const result = await api.get("/api/v1/suppliers/all/");
    if (result && result.status == 200) return result.data.data;
    return null;
  }

  static async put(payload) {
    const result = await api.put(`/api/v1/suppliers/${payload.id}/`, payload);
    if (result && result.status == 200) return result.data.data;
    return null;
  }

  static async supplies(id, params) {
    const result = await api.get(
      `/api/v1/suppliers/view_supplies/${id}/`,
      params
    );
    if (result && result.status == 200) return result.data;

    return null;
  }

  static async addSupplies(payload) {
    const result = await api.post(
      `/api/v1/suppliers/create_supplies/`,
      payload
    );
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async deleteSupplies(payload) {
    const result = await api.post(`/api/v1/suppliers/delete_supply/`, payload);
    if (result && result.status == 200) return result.data;

    return null;
  }

  static async partOptions(id) {
    const result = await api.get(
      `/api/v1/suppliers/get_available_parts/${id}/`
    );
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static rules() {
    return {
      name: [{ required: true, message: "Name is required.", trigger: "blur" }],
      contact_person: [
        {
          required: true,
          message: "Contact Person is required.",
          trigger: "blur"
        }
      ],
      address: [
        { required: true, message: "Address is required.", trigger: "blur" }
      ],
      contact: [
        { required: true, message: "Contact is required.", trigger: "blur" }
      ],
      contact_title: [
        {
          required: true,
          message: "Contact Title is required.",
          trigger: "blur"
        }
      ],
      telephone: [
        { required: true, message: "Telephone is required.", trigger: "blur" }
      ],
      currency_id: [
        {
          required: true,
          message: "Currency information is required"
        }
      ]
    };
  }
}
